import React from 'react'
import PfgCompUpdated from './pfgCompUpdated'

function Pfg() {
  return (
    <PfgCompUpdated/>
  )
}

export default Pfg